'use strict';

var dialog = require('./dialog'),
	validator = require('./validator'),
	linchpin = require('int_googletagmanager/linchpin/emailsignup'),
	linchpinError = require('int_googletagmanager/linchpin/error'),
	reCaptcha = require('int_recaptcha/recaptcha');

var renderThankYouDialog = function () {
	dialog.open({
		url:Urls.signupThankYou,
		options: {
			dialogClass: 'email-signup-dialog no-title',
			open: function () {
				$('#email-sign-up-thank-you button').click(function () {
					dialog.close();
				});
			}
		}
	});
};
var signUpDialogPrepare = function (email) {
	var $dialogForm = $('.footerEmailSignUpPopUp form');

	validator.initForm($dialogForm);
	$dialogForm.find('[id$=email]').val(email);
	$dialogForm.find('input[type=checkbox]').uniform();

	$dialogForm.on('submit', function (e) {
		e.preventDefault();
		if ($(this).valid()) {
			$dialogForm.find('button[type="submit"]').prop('disabled', true);
			$.ajax({
				url:$dialogForm.attr('action'),
				method:'POST',
				data: $dialogForm.serialize(),
				dataType:'json'
			}).done(function (response) {
				if (response.success) {
					renderThankYouDialog();
				} else {
					$('.footerEmailSignUpPopUp .error-msg').html(response.msg).show();
					$dialogForm.find('button[type="submit"]').prop('disabled', false);
				}
			}).fail(function () {
				//@TODO internal dw error
			});
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.emailSignupEvent(e, $dialogForm);
			}
		} else {
			reCaptcha.resetRecaptchaForms('.footerEmailSignUpPopUp form');
		}
	});
	reCaptcha.initRecaptchaOnForm('.footerEmailSignUpPopUp form', function() {
		$dialogForm.trigger('submit');
	});
};

exports.init = function () {
	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		$('[id$=emailshow]').on('change', function () {
			linchpinError.pushSingleErrorObject($(this));
		});
	}
	$('.footer-signup button[type="submit"]').on('click touchstart', function (e) {
		var $form = $('.email-signup form'),
			email = $form.find('[id$=emailshow]');

		// Fix for dialog positioning issue on Ipad
		var userAgent = (navigator.userAgent).toLowerCase();
		if (userAgent.indexOf('ipad') !== -1) {
			window.scrollTo(0, +$(window).scrollTop() - 400);
		}

		e.preventDefault();
		if ($form.valid()) {
			dialog.open({
				url: $form.attr('action'),
				options: {
					dialogClass: 'email-signup-dialog no-title',
					open: function () {
						signUpDialogPrepare(email.val());
					}
				}
			});
		} else {
			$form.validate().element(email);
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpinError.pushSingleErrorObject(email);
			}
		}
	});
};

